import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildObvTileConfigSlice } from 'widgets/obvTile/store/config/configslice';
import { ObvTileState } from 'widgets/obvTile/store/ObvTileState';
import { ObvTileActionPayload } from 'widgets/obvTile/store/actions';

const { reducer: configReducer } = buildObvTileConfigSlice();

const obvTileWidgetReducer = combineReducers<ObvTileState>({
    config: configReducer,
});

export const obvTileWidgetsReducer = createWidgetsReducer<
    ObvTileState,
    ObvTileActionPayload
>(WidgetType.OBV_TILE, obvTileWidgetReducer);
